var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2291_4185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2817 0.919678H11.2994C7.75562 0.919678 4.88281 3.79248 4.88281 7.33623V18.3185C4.88281 21.8623 7.75562 24.7351 11.2994 24.7351H22.2817C25.8254 24.7351 28.6982 21.8623 28.6982 18.3185V7.33623C28.6983 3.79248 25.8255 0.919678 22.2817 0.919678Z",
    fill: "#E81E83",
    fillOpacity: 0.54,
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7906 18.575C19.9654 18.575 22.5391 16.0013 22.5391 12.8264C22.5391 9.6516 19.9654 7.07788 16.7906 7.07788C13.6157 7.07788 11.042 9.6516 11.042 12.8264C11.042 16.0013 13.6157 18.575 16.7906 18.575Z",
    fill: "#E81E83",
    fillOpacity: 0.54,
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5027 5.84708C24.5027 6.25126 24.1751 6.57892 23.7709 6.57892C23.3667 6.57892 23.0391 6.25126 23.0391 5.84708C23.0391 5.44289 23.3667 5.11523 23.7709 5.11523C24.1751 5.11523 24.5027 5.44289 24.5027 5.84708Z",
    fill: "#E81E83",
    fillOpacity: 0.54,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.3478,
    cy: 4.86222,
    r: 0.952311,
    fill: "black",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2291_4185",
    x: 0.382812,
    y: 0.419678,
    width: 32.8154,
    height: 32.8154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2291_4185"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2291_4185",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.e8464e8d9e91729e27d9b790451df10d.svg";
export { ForwardRef as ReactComponent };